import getBrandSubscriptionStoreForAccount from '../store/Store';
import type BrandSubscriptionModel from '../store/schema/BrandSubscriptionModel';
import type { MailboxInfo } from 'owa-client-types';

function getSubscriptionFromCache(
    smtpAddress: string | undefined,
    mailboxInfo: MailboxInfo
): BrandSubscriptionModel | undefined {
    if (!smtpAddress) {
        return undefined;
    }

    const accountStore = getBrandSubscriptionStoreForAccount(mailboxInfo);
    const key = smtpAddress.toLowerCase();

    if (accountStore.subscriptions.has(key)) {
        return accountStore.subscriptions.get(key);
    }

    return undefined;
}

export { getSubscriptionFromCache };
